import axios from 'axios';

export function esPerfilCliente(user) {
  return Boolean(user && (user.perfil_cliente === true || user.cliente_id != null));
}

export function rutaInicio(user) {
  return esPerfilCliente(user) ? '/cliente/pedidos' : '/';
}

export function redireccionInicio(to, user) {
  if (to.path === '/' && esPerfilCliente(user)) return rutaInicio(user);
  if (to.path === '/cliente/pedidos' && !esPerfilCliente(user)) return '/';
  return null;
}

export const pedidosCliente = {
  catalogo: () => axios.get('/api/cliente/pedidos/catalogo'),
  listar: (params) => axios.get('/api/cliente/pedidos', { params }),
  consultar: (id) => axios.get(`/api/cliente/pedidos/${id}`),
  crear: (data) => axios.post('/api/cliente/pedidos', data),
  editar: (id, data) => axios.put(`/api/cliente/pedidos/${id}`, data),
  cancelar: (id, justificacion) => axios.put(`/api/cliente/pedidos/${id}/cancelar`, { justificacion }),
};
